import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AccountingServicesSection from "./components/AccountingServicesSection";
import TaxationServicesSection from "./components/TaxationServicesSection";
import MPFServicesSection from "./components/MPFServicesSection";
import AboutUsSection from "./components/AboutUsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <AccountingServicesSection />
        <TaxationServicesSection />
        <MPFServicesSection />
        <AboutUsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
